import form from './form';
import requestForm from './reqForm';
import table from './table';

export default {
  layout: 'peer-reference-layout',
  form,
  requestForm,
  table,
};
